import {
    useProfileStore,
} from '../../stores/profile-store';
import {
    useAuth,
} from '../../stores/user-store';

export default function fetchProfile() {
    const auth = useAuth();
    const profile = useProfileStore();
    if (!auth.isLoggedIn || profile.exists) return true;

    profile.fetchProfile();
    return true;
}
